import { z } from "zod";

//QualidadeItemProcessosIndicadorSchema

const optionalNumber = z.coerce.number().int().nullable().optional();
const optionalString = z.coerce.string().trim().nullable().optional().transform(e => e === '' ? null : e);
export const QualidadeItemProcessosIndicadorSchema = z.object({
    IdItemProcessoIndicador: optionalNumber,
    IdItemProcesso: optionalNumber,
    IdIndicador: z.array(z.number()).optional().default([]),
    Item: optionalString,
})

// QualidadeItemProcessosIndicadorForm

export type QualidadeItemProcessosIndicadorForm = z.infer<typeof QualidadeItemProcessosIndicadorSchema>;